import { useSelector } from 'react-redux';
import { selectStatusById } from '@store/selectors/solicitacaoSelector';
import { useAppAuth } from '@contexts/AuthContext';

export const useDisableIfStatusAndRole = (
    idSolicitacao,
    allowedStatuses,
    allowedRoles
) => {
    const status = useSelector(selectStatusById(idSolicitacao));
    const { role } = useAppAuth();
    const userRole = role;

    const canEdit =
        allowedStatuses.includes(status) && allowedRoles.includes(userRole);

    return canEdit;
};
